interface HelpListItemStyle {
  backgroundColor: string;
  backgroundHoverColor: string;
  titleColor: string;
  iconColor: string;
  iconHoverColor: string;
}

export const helpListItemStyleDark: HelpListItemStyle = {
  backgroundColor: 'rgb(32, 41, 63)',
  backgroundHoverColor: 'rgb(37, 46, 68)',
  titleColor: 'rgb(213, 226, 258);',
  iconColor: 'rgb(163, 176, 208)',
  iconHoverColor: 'orange',
};

export const helpListItemStyleLight: HelpListItemStyle = {
  backgroundColor: 'rgba(0, 5, 40, 0.02)',
  backgroundHoverColor: 'rgba(0, 5, 40, 0.03)',
  titleColor: 'rgb(53, 66, 98)',
  iconColor: 'rgb(113, 126, 158)',
  iconHoverColor: 'orange',
};